export const isInvitationExpired = (date: string) => {
    const now = new Date();
    const expiryDate = new Date(date);

    return now > expiryDate;
};
